module.exports = __webpack_public_path__ + "static/media/offer-active.b922f77e.svg";